function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 8,
  width: 16,
  height: 16,
  rx: 8,
  fill: "#FF785A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M68.846 48.969L63.942 68.9178C63.7912 69.5347 63.1965 69.9996 62.558 70L31.7006 70C31.3258 70.0016 30.956 69.8504 30.6907 69.5872L11.4075 50.412C9.3747 48.4972 9.69371 44.5165 11.4075 42.3155C11.8682 41.8022 13.034 40.405 14.2329 39.8533C15.4317 39.3016 18.6043 38.3306 20.9331 39.8533L27.3241 45.2839C27.6381 45.5943 28.0375 45.8054 28.472 45.8906C28.9065 45.9758 29.3566 45.9313 29.7657 45.7627C30.1748 45.5941 30.5246 45.309 30.7711 44.9432C31.0175 44.5774 31.1496 44.1473 31.1508 43.707V16.4993C31.1508 14.143 32.7522 11.8148 35.0111 10.8195C37.6531 9.65539 39.5982 9.79052 42.1786 10.8523C44.2854 11.7192 45.9181 13.7779 45.9045 16.1376V30.9504C45.9018 32.1141 46.2475 33.2523 46.8977 34.2199C47.5479 35.1875 48.4731 35.9409 49.5554 36.3839L65.8647 43.0781C66.9907 43.54 67.9117 44.3896 68.4592 45.4714C69.0066 46.5532 69.144 47.7948 68.846 48.969Z",
  strokeWidth: 6
});

var SvgIcoByhandRed = function SvgIcoByhandRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    stroke: "black",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoByhandRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-byhand-red.e5acfbb1.svg";
export { ForwardRef as ReactComponent };